/* global IS_PRODUCTION */
import { chunk, get, has, pick, isEqual } from 'lodash-es'
import axios from '@/js/helper/axios-helper.js'
import { stringify } from 'qs'

const variantRequestMaximum = 40

export default {
  data() {
    return {
      availabilityMixinAvailabilities: {},
    }
  },
  methods: {
    clearAvailabilities() {
      this.availabilityMixinAvailabilities = {}
    },
    updateAvailabilities(newAvailabilities) {
      console.log('🚀 ~ updateAvailabilities ~ newAvailabilities:', newAvailabilities)

      this.availabilityMixinAvailabilities = {
        ...this.availabilityMixinAvailabilities,
        ...Object.entries(newAvailabilities).reduce((acc, [key, val]) => {
          console.log(
            '🚀 ~ updateAvailabilities ~ isEqual:',
            isEqual(val, this.availabilityMixinAvailabilities[key]),
          )

          if (!isEqual(val, this.availabilityMixinAvailabilities[key]) && has(val, 0)) {
            val[0].change = true
          }
          acc[key] = val
          return acc
        }, {}),
      }
      console.log(
        '🚀 ~ updateAvailabilities ~ this.availabilityMixinAvailabilities:',
        this.availabilityMixinAvailabilities,
      )
    },
    getAvailability(sku) {
      console.log('🚀 ~ getAvailability ~ sku:', sku)
      return Array.isArray(sku)
        ? pick(this.availabilityMixinAvailabilities, sku)
        : get(this.availabilityMixinAvailabilities, sku)
    },
    async fetchSkuAvailability({ sku = [], clear = false, force = undefined }) {
      let cleared = false

      const singles = chunk(sku, variantRequestMaximum)

      for (const singlePart of singles) {
        console.log(`fetchSkuAvailability singles count: (${singlePart.length})`, singlePart)
        await this.availabilityMixinDoRequest(
          { skus: singlePart, force },
          'sku-availability',
          clear && !cleared,
        )
        cleared = clear
      }
    },
    async fetchAvailability({
      id = [],
      sku = [],
      itemids = [],
      endpoint = 'availability',
      clear = false,
      force = undefined,
    }) {
      // console.log('fetchAvailability', { id, sku, itemids })
      let cleared = false

      const selectids = Array.isArray(id) ? id : [id]
      const singles = chunk(
        [
          ...(Array.isArray(sku) ? sku : [sku]).map(item => ({ type: 'skus', value: item })),
          ...(Array.isArray(itemids) ? itemids : [itemids]).map(item => ({
            type: 'itemids',
            value: item,
          })),
        ],
        variantRequestMaximum,
      )

      for (const selectId of selectids) {
        console.log(`fetchAvailability selectId: ${selectId}`)
        await this.availabilityMixinDoRequest({ selectids: selectId, force }, endpoint)
      }

      for (const singlePart of singles) {
        const data = singlePart.reduce(
          (acc, { type, value }) => {
            if (!has(acc, type)) {
              acc[type] = []
            }
            acc[type].push(value)
            return acc
          },
          { force },
        )
        console.log(`fetchAvailability singles count: (${singlePart.length})`, data)
        await this.availabilityMixinDoRequest(data, endpoint, clear && !cleared)
        cleared = clear
      }
    },
    async availabilityMixinDoRequest(data, endpoint = 'availability', clear = false) {
      const requestUrl = `${window.location.origin}/api/bucommonapi?code=${endpoint}&${stringify(
        data,
      )}`

      const params =
        requestUrl.length > 2048
          ? {
              method: 'POST',
              url: `${window.location.origin}/api/bucommonapi?code=availability`,
              data,
            }
          : {
              method: 'GET',
              url: requestUrl,
            }

      try {
        const { data: availabilities } = await axios(params)
        this.availabilityMixinAvailabilities = clear
          ? availabilities
          : {
              ...this.availabilityMixinAvailabilities,
              ...availabilities,
            }
      } catch (error) {
        // TODO: Error Handling
        if (!IS_PRODUCTION) {
          console.error(error)
        }
      }
    },
  },
}
